import { useState, memo } from "react";
import { apiNiches } from "@/common/services";
import { DUPLICATE_CODE, CREATE_NICHE_FIELDS } from "./constants";
import { AxiosError } from "axios";
import { IErrorData } from "@/common/services/types";
import { NicheForm } from "@/components/popups/NicheForm";
import { showNotification } from "@/components/alerts/Notifications";
import { useNavigate } from "react-router";
import { routes } from "@/common/utils/routes";
import { INicheForm } from "@/components/popups/NicheForm/NicheForm";

interface ICreateFormProps {
  handleGoSuccess: () => void;
}

export const CreateForm = memo((props: ICreateFormProps) => {
  const { handleGoSuccess } = props;
  const [ticketId, setTicketId] = useState<string>("");
  const navigate = useNavigate();

  const getError = (error: AxiosError<IErrorData>) => {
    const e = (error as AxiosError<IErrorData>).response?.data?.error;

    if (e?.code === DUPLICATE_CODE) {
      if (e.public && e.niche_id) {
        showNotification({
          title: `A niche named ${e.niche_id} already exists`,
          description: "Click the button below to see it",
          variant: "info",
          actionButton: {
            title: "Go to the niche",
            onClick: () => navigate(routes.niche(e.niche_id as string))
          },
          toastOptions: {
            duration: 10000
          }
        });
        return;
      } else {
        showNotification({
          title: e.message,
          variant: "error"
        });

        return;
      }
    }

    showNotification({
      title: "Error submitting the niche, please try again later.",
      variant: "error"
    });
  };

  const onSubmit = async (data: INicheForm) => {
    try {
      await apiNiches.createNiche({
        name: data.name,
        description: data.description,
        rules: data.rules,
        profile_image: ticketId
      });
      handleGoSuccess();
    } catch (e) {
      console.error(e);
      getError(e as AxiosError<IErrorData>);
    }
  };

  const handleTicketId = (ticketId: string) => {
    setTicketId(ticketId);
  };

  return (
    <NicheForm
      onSubmit={onSubmit}
      handleTicketId={handleTicketId}
      ticketId={ticketId}
      fields={CREATE_NICHE_FIELDS}
      btnTitle="Submit"
    />
  );
});

